export default (params) => ({
  trigger: {
    name: 'product_type_section.shown_alternatives',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
    },
    event: {
      name: 'show_accessory_items',
      params: {
        sub_feature: 'product_type_section_alternative_overlay',
      },
    },
    nonInt: true,
  },
});
